import * as React from "react";
import FilterToolbar from "../../../../Components/FiltersToolbar/FilterToolbar";
import { FilterInputType } from "../../../../Enums/FilterTypes";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../../Constants/Constant";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { SourceRequestOrder } from "../../Constant/Source";
import { DataGridColumns } from "./DataGridColumns";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import { Drawer, Grid, makeStyles } from "@material-ui/core";
import RequestOrderNotes from "../../../../../src/Pages/RequestOrder/Components/RequestOrderNotes";
import { RemarkTypes } from "../../../../../src/Enums/RemarkTypes";
import { useVerifyPermission } from "@airborne/react-admin";
import PoolList from "../../../../Components/PoolListComponent/PoolListComponent";

export const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: "20%",
  },
}));

export const DispatchWaitingList = props => {
  useVerifyPermission("customroutes", "dispatchwaiting.read");
  const [isMatchCreate, setIsMatchCreate] = React.useState(false);
  const [requestRemark, setRequestRemark] = React.useState<any>({});
  const classes = useStyles();
  const ExportToExcel = data => {
    ExcelExport(
      [
        {
          header: "Status",
          key: "Status",
        },
        {
          header: "Ref No",
          key: "Ref No",
        },
        {
          header: "Customer Po",
          key: "Customer Po",
        },
        {
          header: "Requested Delivery Date",
          key: "Requested Delivery Date",
        },
        {
          header: "Pn",
          key: "Pn",
        },
        {
          header: "Core Unit Sn",
          key: "Core Unit Sn",
        },
      ],
      data.map(v => [
        v.requestStatus,
        v.refNo,
        v.customerPo,
        v.requestedDeliveryDate,
        v.customerRequestComponent,
        v.unserviceable?.sn,
      ]),
      "Dispatch Waiting List"
    );
  };

  const remarkAddClick = record => {
    setIsMatchCreate(true);
    setRequestRemark(record);
  };

  const handleClose = () => {
    setIsMatchCreate(false);
  };

  return (
    <>
      <PoolList
        {...props}
        title={"Dispatch Waiting List"}
        hasCreate={false}
        exporter={ExportToExcel}
        resource={SourceRequestOrder}
        basePath={SourceRequestOrder}
        hasBulkActions={false}
        filterDefaultValues={{
          isUnsvcInfo__eq: true,
          requestStatus__eq: RequestStatus.Status30,
        }}
        sort={DefaultCreatedDateSort}
        perPage={DefaultPerPageSize}
        filters={
          <FilterToolbar
            dataSource={[
              {
                source: "requestStatus",
                inputType: FilterInputType.Select,
                label: "Status",
                optionText: "label",
                optionValue: "id",
                style: { width: "250px" },
                choices: [{ label: "Status 30", id: RequestStatus.Status30 }],
              },
              {
                source: "refNo",
                inputType: FilterInputType.Text,
                label: "Ref No",
              },
              {
                source: "customerPo",
                inputType: FilterInputType.Text,
                label: "Customer Po",
              },
              {
                source: "requestedDeliveryDate",
                inputType: FilterInputType.Date,
                label: "Requested Delivery Date",
              },
              {
                source: "customerRequestComponent",
                inputType: FilterInputType.Text,
                label: "Pn",
              },
              {
                source: "unserviceable.sn",
                inputType: FilterInputType.Text,
                label: "Sn",
              },
            ]}
          />
        }
      >
        <DataGridColumns remarkAddClick={remarkAddClick} />
      </PoolList>
      {isMatchCreate && (
        <Grid item xs={3}>
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="persistent"
            open={isMatchCreate}
            anchor="right"
            onClose={handleClose}
          >
            {isMatchCreate ? (
              <RequestOrderNotes
                onCancel={handleClose}
                request={requestRemark}
                resource="requestremarks"
                basePath="requestremarks"
                remarkType={RemarkTypes.PbhNote}
              />
            ) : null}
          </Drawer>
        </Grid>
      )}
    </>
  );
};

export default DispatchWaitingList;
